import { ELanguages, GaParams } from 'shared/typings';

import { generateSUID, getClientId, getDateTimeGreenwich, getTimeStamp, getUrlTags, referrer } from './ga';

export const getGaParams = (): GaParams => {
	return {
		event_option1: 'undefined',
		event_option2: 'undefined',
		event_option3: 'contract-and-pay',
		event_option4: 'undefined',

		hit_id: getTimeStamp(),
		uu_id: generateSUID(),
		uu_id_2: generateSUID(),
		datetime_greenwich: getDateTimeGreenwich(),
		datetime_greenwich_2: getDateTimeGreenwich(),

		client_id_ga: getClientId() + '.',
		program_id: 'undefined',
		advertiser_id: 'undefined',
		advcampaign_id: 'undefined',
		publisher_id: localStorage.getItem('user_id') || 'undefined',
		keycloak_id: localStorage.getItem('user_id') || 'undefined',
		website_id: 'undefined',

		locale: window.localStorage.i18nextLng || ELanguages.EN,
		page_params: 'undefined',
		url_tags: getUrlTags(),
		referrer_without_login_page: referrer(),
		ab_test: 'undefined',
		sendbox_id: 'undefined',

		user_id: localStorage.getItem('user_id') || undefined,
	};
};
